<template>

    <div v-if="$route.meta.requiresAuth !== true">
      <router-view/>
      <!--<router-view class="" name="login"></router-view>-->
    </div>
    <baseApp v-else></baseApp>


</template>
<script>
  import baseApp from './baseApp.vue'

  export default {
    components: {
      baseApp,
    },
    name: 'App',

  }
</script>

<style>

  @font-face {
    font-family: 'Gilroy';
    src: url('/static/font/GilroyBold.woff') format("woff"), url('/static/font/GilroyBold.eot') format("eot"), url('/static/font/GilroyBold.ttf') format("truetype");
    font-weight: bold;
    font-style: normal;
  }


  @font-face {
    font-family: 'Gilroy';
    src: url('/static/font/GilroyMedium.woff') format("woff"), url('/static/font/GilroyMedium.eot') format("eot"), url('/static/font/GilroyMedium.ttf') format("truetype");
    font-weight: normal;
    font-style: normal;
  }

 body {
   font-family: 'Gilroy', sans-serif
 }

.ivu-layout {
  padding: 90px 0 0 0;
  font-family: 'Gilroy', sans-serif;
  line-height: 1.2;
  color: #0E254A;
  font-size: 16px;
  background-color: #ffffff;
}

  .main-container__home {
padding: 20px 416px 50px 414px;
  }

  .main-container {
    padding: 20px 40px 50px 250px;
  }
  .ivu-layout-sider-children {
    overflow-y: scroll;
  }

  .ivu-layout-sider-children::-webkit-scrollbar {
    width: 5px;
    height: 8px;
    background-color: transparent; /* or add it to the track */
  }
  .ivu-layout-sider-children::-webkit-scrollbar-thumb {
    width: 5px;
    background: #20BEC8;
    border-radius: 25px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  }
/*******TYPOGRAPHY*******/
  h1 {
    font-size: 26px;
  }
h2 {
  font-size: 20px;
  font-weight: bold;
  color: #0E254A;
  margin: 0;
  transition: 0.3s ease-in;
}
  h3 {
    font-size: 18px;
    font-weight: bold;
    color: #0E254A;
    margin: 0;
    transition: 0.3s ease-in;
  }
  h4 {
    font-size: 30px;
  }
  h5 {
    font-size: 16px;
    font-weight: bold;
    color: #0E254A;
  }
  .font-bold {
    font-weight: bold;
  }
  /*-----*/

  /*******BUTTONS********/
  button.ivu-btn, a.ivu-btn  {
    border-radius: 18px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    padding: 15px 25px;
    line-height: 1.2;
    font-size: 16px;
  }
  button.border_30.ivu-btn, a.border_30.ivu-btn {
    border-radius: 30px;
  }

  .ivu-btn-info {
     background-color: #5087DE;
     border-color: #5087DE;
   }
  .ivu-btn-info:hover {
    background-color: #5296f0;
    border-color: #5296f0;
    box-shadow: 0 4px 7px rgba(0,0,0,0.26);
  }
  .ivu-btn-error {
    background-color: #F16F58;
    border-color: #F16F58;
  }
  .ivu-btn-error:hover {
    background-color: #fd7059;
    border-color: #fd7059;
    box-shadow: 0 4px 7px rgba(0,0,0,0.26);
  }
  .ivu-btn-success {
     background-color: #25D87E;
     border-color: #25D87E;
   }
  .ivu-btn-success:hover {
    background-color: #25dd82;
    border-color: #25dd82;
    box-shadow: 0 4px 7px rgba(0,0,0,0.26);
  }
  .ivu-btn-primary {
    background-color: #ffffff;
    border-color: #ffffff;
    color: #0E254A;
  }
  .ivu-btn-primary:hover {
    background-color: #eeeeee;
    border-color: #eeeeee;
    color: #0E254A;
    box-shadow: 0 4px 7px rgba(0,0,0,0.26);
  }
  button.ivu-btn-small {
    font-size: 14px;
    padding: 10px 12px;
  }


    /*******SWITCH******/
  .ivu-switch {
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    background-color: #ffffff;
    border-color: #ffffff;
    width: 59px;
    height: 38px;
  }
  .ivu-switch::after {
    background-color: #25D77E;
    width: 22px;
    height: 22px;
    top: 8px;
    left: 8px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  }
  .ivu-switch:focus, .ivu-switch:focus:hover,  .ivu-switch:active,  .ivu-switch:hover{
    outline: none;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  }
  .ivu-switch-checked {
    border-color: #25D77E;
    background-color: #25D77E
  }
  .ivu-switch-checked:after {
    background-color: #ffffff;
  }

  .ivu-switch-checked.ivu-switch::after {
    left: auto;
    right: 8px;
  }

  .switch-custom {
    display: flex;
    align-items: center;
  }
  .switch-custom span {
    display: block;
    margin-left: 12px;
    font-size: 16px;
    line-height: 1.5;
    font-weight: bold;
    color: #25D77E;
    text-decoration: underline;
  }

  /******INPUTS*******/
  .ivu-input-inner-container, .ivu-input-wrapper {
    border-radius: 18px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  }

  .border_30 .ivu-input-inner-container, .border_30.ivu-input-wrapper {
    border-radius: 30px;
  }


  input.ivu-input, textarea.ivu-input, .ivu-input-number {
    border: none;
    border-radius: 18px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    padding: 15px 25px;
    line-height: 1.2;
    font-size: 16px;
  }

  .ivu-input-inner-container input.ivu-input,  .ivu-input-wrapper  textarea.ivu-input, .ivu-input-inner-container  .ivu-input-number {
    box-shadow: none;
  }

  .border_30 input.ivu-input, .border_30 textarea.ivu-input, .border_30.ivu-input-number {
    border-radius: 30px;
  }

  textarea.ivu-input {
    resize: none;
  }
  input.ivu-input, .ivu-input-number {
    height: 56px;
  }
  .ivu-input-number-handler-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  input.ivu-input::placeholder, textarea.ivu-input::placeholder {
    /*font-weight: bold;*/
  }

  input.ivu-input:focus, input.ivu-input:active, textarea.ivu-input:focus, textarea.ivu-input:active {
    outline: none;
    box-shadow: 0 4px 7px rgba(0,0,0,0.26);
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  .target_table .ivu-input-number {
    height: auto;
    padding: 0 15px;
    text-align: center;
  }
    /******search********/
  .ivu-input-suffix {
    display: flex;
    align-items: center;
    background-color: transparent;
    border-radius: 18px;
    height: 52px;
  }
  .ivu-input-suffix i,  i.ivu-icon {
    font-size: 20px;
  }
  .ivu-form label.ivu-form-item-label {
    font-size: 16px;
  }

  .ivu-date-picker input {
    max-width: 260px;
    background-color: #5087DE;
    color: #FFFFFF;
    font-weight: bold;
  }
  .ivu-date-picker .ivu-input-suffix {
    background-color: transparent;
  }
  .ivu-date-picker .ivu-input-suffix i {
    color: #ffffff
  }
  .ivu-date-picker .ivu-picker-panel-icon-btn i {
    font-size: 14px;
  }
  .ivu-date-picker .ivu-picker-confirm-time {
    margin-bottom: 12px;
  }
  /******UPLOADS******/
  .ivu-upload-drag  {
    background-color: #F1F1F1;
    border-radius: 30px;
    font-size: 18px;
    color: #5087DE;
    border-color: #707070;
  }



  label.ivu-form-item-label, label {
    color: #acacac;
    font-size: 15px;
    margin-bottom: 5px;
    display: block;
  }




  /*******TABS*******/
  .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper, .ivu-radio-group label.ivu-radio-group-item {
    border: none;
    font-size: 14px;
    border-radius: 20px;
    padding: 15px 0;
    height: auto;
    background-color: #F1F1F1;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    margin-right: 24px;
    text-transform: uppercase;
    line-height: 1.2;
    display: flex;
    align-items: center;
  }
  .ivu-radio-group {
    display: inline-flex;
  }
  .ivu-radio-group label.ivu-radio-group-item:first-child, .ivu-radio-group label.ivu-radio-group-item:last-child {
    border-radius: 20px;
  }

  .ivu-radio-group label.ivu-radio-group-item {
    padding: 15px 20px;
  }

  .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper:hover, .ivu-tabs-nav .ivu-tabs-tab:hover, .ivu-radio-group label.ivu-radio-group-item:hover {
    box-shadow: 0 4px 7px rgba(0,0,0,0.26);
    color: #515a6e;;
  }
  .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper-checked, .ivu-radio-group label.ivu-radio-group-item.ivu-radio-wrapper-checked  {
    border: none;
    background-color: #5087DE;
    color: #ffffff
  }
  .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper-checked:hover {
    color: #ffffff
  }
  .ivu-radio-group-button .ivu-radio-wrapper-checked:before, .ivu-radio-group-button .ivu-radio-wrapper-checked:after, .ivu-radio-group-button .ivu-radio-wrapper:before {
    content: none;
  }
  .ivu-radio-group-button .ivu-radio-wrapper:first-child {
    border-right: none;
    border-left: none;
  }
  .ivu-radio-group-button .ivu-radio-wrapper-checked:first-child,  .ivu-radio-group-button .ivu-radio-wrapper-checked:last-child{
    border-left: none;
    border-right: none;
  }
  .ivu-tabs-nav {
    padding: 5px;
  }
  .ivu-tabs-bar {
    border-bottom: none;
  }
  .ivu-tabs-nav .ivu-tabs-tab .ivu-icon {
    width: auto;
    height: auto;
  }
  .ivu-tabs-nav .ivu-tabs-ink-bar {
    display: none;
  }
  .ivu-tabs-nav .ivu-tabs-tab {
    background-color: #F1F1F1;
    border-radius: 20px;
    font-size: 16px;
    padding: 15px 40px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    margin-bottom: 10px;
    transition: 0.3s ease-in;
  }

  .ivu-tabs-nav .ivu-tabs-tab:last-child {
    margin-right: 0;
  }
  .ivu-tabs-nav .ivu-tabs-tab:after, .ivu-tabs-nav:before, .ivu-tabs-nav:after {
    content: none;
  }

  .ivu-tabs-nav .ivu-tabs-tab.ivu-tabs-tab-active {
    background-color: #5087DE;
    color: #ffffff;
  }




    /*****CHECKBOX******/
  .ivu-checkbox-inner {
    margin-right: 10px;
  }
  .ivu-checkbox-checked .ivu-checkbox-inner {
    background-color: #5087DE;
    border-color: #5087DE;
  }
  .ivu-checkbox-checked .ivu-checkbox-inner:after, .ivu-checkbox-inner:after {
    bottom: 1px;
    display: block;
  }
  .ivu-checkbox-wrapper.ivu-checkbox-large {
    font-size: 16px;
  }


    /*******MODAL********/
  .ivu-modal {
    border-radius: 25px;
    /*border: 3px solid #5087DE;*/
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    font-size: 14px;
  }

  .ivu-modal .ivu-modal-content {
    border-radius: 25px;
  }
  .ivu-modal .ivu-modal-close {
    top: 0
  }

  .ivu-modal .ivu-modal-close .ivu-icon-ios-close {
    font-size: 50px;
    color: #0E254A;
  }

  .modal_hide_close .ivu-modal-close {
    display: none;
  }

  .preview_modal p span {
    position: relative;
    display: inline-block;
  }

  .preview_modal p span:after {
    content: url("/static/svg/video_active.svg");
    position: relative;
    right: 0;
    top: 7px;
    margin-left: 10px;
  }


    /******SELECT*******/
  .ivu-select-input {
    font-size: 16px;
    min-height: 56px;
    padding: 0 24px;
  }
  .ivu-select .ivu-select-selection{
    font-size: 16px;
    border: none;
    height: auto;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    border-radius: 25px;
  }
  .ivu-select .ivu-select-selection:hover {
    box-shadow: 0 4px 7px rgba(0,0,0,0.26);
    border: none;
  }
  .ivu-select .ivu-select-selection .ivu-select-placeholder, .ivu-select .ivu-select-selection .ivu-select-selected-value {
    font-size: 16px;
    color: #0E254A;
    font-weight: bold;
  }
  .ivu-select .ivu-select-item {
    font-size: 16px !important;
  }

  .ivu-select-single .ivu-select-selection .ivu-select-selected-value, .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
    height: auto;
    padding: 12px 35px 12px 20px;
  }

  /******TABLE*******/

  .desktop_table {
    display: block;
  }

  .ivu-table:before, .ivu-table:after {
    content: none;
  }
  .ivu-table-body table {
    border-spacing: 0 24px;
    overflow: visible;
  }
  .ivu-table-wrapper {
    border: none;
    overflow: visible;
  }
  .ivu-table {
    overflow: visible;
  }

  .ivu-table .ivu-table-header th{
    color: rgba(77, 79, 92, 0.5);
  }

  .ivu-table th {
    background-color: transparent;
    color: #4D4F5C;
    font-size: 15px;
    border: none;
    font-weight: normal;
  }
  .ivu-table td {
    background-color: transparent;
    margin-bottom: 25px;
    border-bottom: none;
    height: 56px;
  }

  .ivu-table tr.ivu-table-row {
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    border: 1px solid rgba(0,0,0,0.1);
    background-color: rgba(206, 206, 206, 0.05);
    margin-bottom: 23px;
    border-radius: 25px;
    font-size: 15px;
  }

  .ivu-table .ivu-table-row td {
    margin-bottom: 25px;
  }
  .ivu-table .ivu-table-row td:first-child {
    border-radius: 25px 0 0 25px;
   }
  .ivu-table .ivu-table-row td:last-child {
    border-radius: 0 25px 25px 0;
  }
  .one-col-table .ivu-table-row td, .one-col-table .ivu-table-row td:last-child {
    border-radius: 25px;
  }

  .ivu-table .ivu-table-row-hover {
    background-color: rgba(37, 215, 126, 0.8);
  }
  .ivu-table .ivu-table-row-hover td{
    background-color: transparent;
  }

  .ivu-table .ivu-table-row .ivu-input-suffix i, i.ivu-icon {
    font-size: 24px;
  }
  .ivu-table-cell {
    word-break: normal;
  }

  .ivu-table-sort {
    height: 14px;
  }
  .ivu-table-sort  i.ivu-icon {
    font-size: 18px;
  }

  .report__table td.ivu-table-expanded-cell {
    padding: 0 10px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    border-radius: 18px;
  }

  /************MOBILE TABLE**********/

  .mobile-table {
    display: none;
  }
  .mobile-table .card-container{
    margin-bottom: 15px;
    padding: 8px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .mobile-table .card-container h2 {
    margin-bottom: 4px;
  }

  .mobile-table .card-container p {
    margin-bottom: 2px;
    font-size: 9px;
    color: #6D82A3
  }

  .mobile-table .card-container p.price {
    font-size: 16px;
    color: #0E254A;
    white-space: nowrap;
  }


  .ivu-tag {
    height: auto;
    line-height: 1;
  }
  .ivu-tag-warning, .ivu-tag-success {
    background-color: #ffffff;
  }
  .ivu-tag-warning span.ivu-tag-text{
    color: #ED4729 !important;
    font-size: 15px;
    padding: 4px 0;
    display: block;
  }
  .ivu-tag-success span.ivu-tag-text{
    color: #25D77E !important;
    font-size: 15px;
    padding: 4px 0;
    display: block;
  }
  .ivu-tag-closable {
    border-radius: 20px;
    border: 1px solid #0E254A;;
    background-color: #ffffff;
  }


    /*drawer*/
  .ivu-drawer{
    font-family: 'Gilroy', sans-serif;
    line-height: 1.2;
    color: #0E254A;
    font-size: 16px;
  }
  .ivu-drawer .ivu-drawer-body{
    padding: 40px;
  }


    /*PAGE*/
  .ivu-page .ivu-page-item {
    border: none;
    border-radius: 22px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    padding: 12px 20px;
    height: auto;
    font-family: 'Gilroy', sans-serif;
    transition: 0.3s ease-in;
  }

  .ivu-page .ivu-page-item:hover {
    box-shadow: 0 4px 7px rgba(0,0,0,0.26);
  }
  .ivu-page .ivu-page-item:hover a, .ivu-page .ivu-page-item:focus, .ivu-page .ivu-page-item:active{
    color: #0E254A
  }

  .ivu-page .ivu-page-item a {
    font-family: 'Gilroy', sans-serif;
    color: #0E254A;
  }
  .ivu-page .ivu-page-item.ivu-page-item-active {
    color: #ffffff;
    font-weight: bold;
    background: #25D77E;
  }
  .ivu-page .ivu-page-item.ivu-page-item-active a {
    color: #ffffff
  }

  .ivu-page .ivu-page-prev, .ivu-page .ivu-page-next {
    border: none;
  }



    /*COMMON STYLES*/
a {
  color: #0E254A;
  transition: 0.3s ease-in;
}
  a:hover {
    color: #102972;
  }
.d-flex {
  display: flex;
}
.align-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}

.cursor-pointer {
  cursor: pointer;
}

.text-transform {
  text-transform: uppercase;
}

.no-wrap {
  white-space: nowrap;
}

.card-container {
  border-radius: 25px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.25);
  background-color: #ffffff;
  transition: 0.3s ease-in;
}
  .card-container:hover {
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
  }

.color-grey {
color: rgba(109, 130, 163, 0.55)
}

.fs-16 {
  font-size: 16px;
}
.fs-15 {
  font-size: 15px;
}
.fs-14 {
  font-size: 14px!important;
}
.mb-5 {
  margin-bottom: 5px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-15 {
  margin-bottom: 15px;
}
.mb-24 {
  margin-bottom: 24px;
}
.mb-30 {
  margin-bottom: 30px;
}
  .mb-40 {
    margin-bottom: 40px;
  }
.mb-50 {
  margin-bottom: 50px;
}

.br-18 .ivu-select-selection{
  border-radius: 18px;
}

.ivu-modal .ivu-modal-body h3 {
  padding-right: 30px;
}

  /*MENU MODAL*/
  .modalMenu .ease-enter-active {
    animation-name: ivuMoveLeftIn;

  }
  .modalMenu .ivu-modal-mask, .modalMenu .ivu-modal-wrap {
    z-index: 100 !important;
  }
  .modalMenu .ease-leave-active {
    animation-name: ivuMoveLeftOut;
  }
  .modalMenu .ivu-modal .ivu-modal-content {
    border-radius: 0;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .modalMenu .ivu-modal {
    border: none;
    width: 414px !important;
  }
  .modalMenu .ivu-modal .ivu-modal-body {
    padding: 0;
    height: 100%;
  }
  .modalMenu .ivu-modal .mainMenu {
    padding: 115px 40px 40px;
    max-height: 100vh;
    overflow-y: scroll;
    height: 100%;
  }

  .modalMenu .ivu-modal .mainMenu::-webkit-scrollbar {
    width: 5px;
    height: 8px;
    background-color: transparent; /* or add it to the track */
  }
  .modalMenu .ivu-modal .mainMenu::-webkit-scrollbar-thumb {
    width: 5px;
    background: #20BEC8;
    border-radius: 25px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  }

  .modalMenu .ivu-modal .ivu-modal-close {
    display: none;
  }


  .modalMenu .ivu-modal .ivu-modal-footer {
    display: none;
  }


  /*DRAWER*/

  .drawer_modal .ivu-drawer{
    width: 700px !important;
    max-height: 80vh;
    min-height: 50vh;
    margin-top: 10vh;
    /*top: 50% !important;*/
    right: 60px;
    /*transform: translateY(-50%) !important;*/
    border: 3px solid #5087DE;
    border-radius: 25px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    overflow-y: visible;
  }
  .drawer_modal .ivu-drawer .ivu-drawer-close {
    display: none;
  }
  .drawer_modal .ivu-drawer .ivu-drawer-content {
    border-radius: 25px;
    overflow-y: scroll;
    position: relative;
  }

  .drawer_modal .ivu-drawer .ivu-drawer-content::-webkit-scrollbar, .drawer_modal .ivu-drawer .ivu-drawer-body::-webkit-scrollbar {
    width: 5px;
    height: 8px;
    background-color: transparent; /* or add it to the track */
  }
  .drawer_modal .ivu-drawer .ivu-drawer-content::-webkit-scrollbar-thumb, .drawer_modal .ivu-drawer .ivu-drawer-body::-webkit-scrollbar-thumb {
    width: 5px;
    background: #5087DE;
    border-radius: 25px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
  }
  .drawer_modal .ivu-drawer .ivu-drawer-body {
    position: relative;
  }

  .drawer_modal .ivu-drawer .ls_drawer_footer {
    position: fixed;
    bottom: 10vh;
    right: 350px;
    z-index: 2;
    display: flex;
    transform: translate(25%, 50%);
  }
  .drawer_modal .ivu-drawer .ls_drawer_footer button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
  }

  .text-right {
    text-align: right;
  }
  .text-center {
    text-align: center;
  }


  .custom-dropdown .ivu-dropdown {
    position: relative;
  }
  .custom-dropdown .ivu-dropdown .ivu-select-dropdown {
    width: 100%;
    right: 0;
    left: auto!important;
  }

  .ivu-dropdown .ivu-select-dropdown .ivu-dropdown-item {
    font-size: 16px !important;
    padding: 7px 16px;
    color: #515a6e;
  }


  .videoList .ivu-select-dropdown {
    min-width: 500px;
    border-radius: 25px;
    padding: 20px 30px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
    top: 90px !important;
  }
  .videoList .ivu-select-dropdown .ivu-dropdown-menu {
    min-width: 100%;
  }
  .videoList .ivu-dropdown-menu .ivu-dropdown-item {
    white-space: normal;
    border-radius: 25px;
    margin-bottom: 12px;
  }


  .video_modal {
    padding: 0;
  }

  .video_modal .ivu-modal-body, .video_modal .ivu-modal {
    padding: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }

  .video_modal .ivu-modal-close {
    display: none;
  }
  .video_modal .ivu-modal-content {
    background-color: transparent;
    box-shadow: none;
  }


  .ivu-modal-wrap {
    background-color: rgba(255, 255, 255, 0.5)
  }





  /******************  ADAPTIVE ********************/
  @media screen and (max-width: 1900px) {
    .ivu-layout {
      padding: 90px 0 0 0;
      font-size: 15px;
    }

    .main-container__home {
      padding: 0px 360px 40px 365px;
    }

    .main-container {
      padding: 20px 40px 40px 220px;
    }

    .modalMenu .ivu-modal {
      width: 365px !important;
    }
    .modalMenu .ivu-modal .mainMenu {
      padding: 108px 40px 20px;
    }


    .ivu-select .ivu-select-item {
      font-size: 15px !important;
    }

  .ivu-select .ivu-select-selection .ivu-select-placeholder {
    font-size: 15px;
  }

    h2 {
      font-size: 18px;
    }
    h3 {
      font-size: 16px;
    }
    h4 {
      font-size: 26px;
    }
    h5 {
      font-size: 15px;
    }

    .fs-16 {
      font-size: 15px;
    }
    .fs-15 {
      font-size: 14px;
    }
    .fs-14 {
      font-size: 14px;
    }
    .mb-24 {
      margin-bottom: 20px;
    }
    .mb-30 {
      margin-bottom: 24px;
    }
    .mb-40 {
      margin-bottom: 30px;
    }
    .mb-50 {
      margin-bottom: 40px;
    }

    button.ivu-btn, a.ivu-btn  {
      padding: 10px 15px;
      font-size: 15px;
      height: 46px;
    }

    input.ivu-input, textarea.ivu-input, .ivu-input-number {
      padding: 10px 15px;
      font-size: 15px;
      height: 46px;
    }

    .ivu-checkbox-wrapper.ivu-checkbox-large {
      font-size: 15px;
    }




    .ivu-form label.ivu-form-item-label, .ivu-select-input {
      font-size: 15px;
    }

    .ivu-table th {
      font-size: 15px;
    }
    .ivu-table td {
      height: 46px;
    }

    .ivu-table .ivu-table-row {
      font-size: 13px;
      box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    }

    .ivu-tag-warning span.ivu-tag-text{
      font-size: 14px;
    }
    .ivu-tag-success span.ivu-tag-text{
      font-size: 14px;
    }

    .ivu-select-single .ivu-select-selection .ivu-select-selected-value, .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
      padding: 8px 35px 8px 15px;
    }

    .ivu-page .ivu-page-item {
      padding: 8px 15px;
      border-radius: 18px;
    }
    .ivu-select-input {
      min-height: 46px;
    }

    .ivu-tabs-nav .ivu-tabs-tab {
      padding: 10px 25px;
    }

    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper, .ivu-radio-group label.ivu-radio-group-item {
      padding: 10px;
      height: 46px;
      display: inline-flex;
      align-items: center;
    }

    .ivu-switch {
      width: 36px;
      height: 24px;
    }
    .ivu-switch::after {
      width: 16px;
      height: 16px;
      top: 4px;
      left: 4px;
    }
    .ivu-switch-checked.ivu-switch::after {
      right: 4px;
    }

    .switch-custom span {
      font-size: 14px;
    }




  }

  /*  ADAPTIVE */
  @media screen and (max-width: 1500px) {
    .ivu-layout {
      padding: 81px 0 0 0;
      font-size: 14px;
    }



    .main-container__home {
      padding: 0 260px 40px 305px;
    }

    .main-container {
      padding: 10px 40px 40px 220px;
    }

    .modalMenu .ivu-modal {
      width: 315px !important;
    }
    .modalMenu .ivu-modal .mainMenu {
      padding: 80px 40px 20px;
    }



    .ivu-tabs-nav .ivu-tabs-tab {
      font-size: 14px;
    }



    h2 {
      font-size: 15px;
    }
    h3 {
      font-size: 14px;
    }
    h4 {
      font-size: 22px;
    }
    h5 {
      font-size: 14px;
    }

    .fs-16 {
      font-size: 14px;
    }
    .fs-15 {
      font-size: 14px;
    }
    .fs-14 {
      font-size: 13px;
    }

    .ivu-table th {
      font-size: 13px;
    }
    .ivu-table .ivu-table-row {
      font-size: 13px;
      box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    }

    .ivu-table-cell {
      padding: 0 12px;
    }

    .ivu-tag-warning span.ivu-tag-text{
      font-size: 13px;
    }
    .ivu-tag-success span.ivu-tag-text{
      font-size: 13px;
    }

    .ivu-dropdown .ivu-select-dropdown .ivu-dropdown-item {
      font-size: 14px !important;
    }
  }




  /**********************  ADAPTIVE *************************/
  @media screen and (max-width: 1200px) {
    .ivu-layout.ivu-layout-has-sider {
      flex-direction: column;
    }

    .main-container__home {
      padding: 0 40px 50px 40px;
    }
    .main-container {
      padding: 20px 40px 50px 40px;
    }

    .modalMenu .ivu-modal {
      width: 400px !important;
    }

    .videoList .ivu-select-dropdown {
      top: 70px!important;
      transform: translateX(50%);
    }
  }



  /*  ADAPTIVE */
  @media screen and (max-width: 991px) {

    .mobile-table {
      display: block;
    }

    .desktop_table {
      display: none;
    }

    .report__table td.ivu-table-expanded-cell {
      padding: 0;
      box-shadow: none;
      border-radius: 0;
    }


    .ivu-page .ivu-page-item {
      padding: 4px 10px;
      margin-bottom: 10px;
    }

    .ivu-page-options .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
      padding: 4px 35px 4px 15px;
      margin-bottom: 10px;
    }

    .drawer_modal .ivu-drawer{
      margin-top: 10vh;
      /*top: 50% !important;*/
      top: auto;
      right: 0;
      left: 0;
      bottom: 0;
      border: none;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      width: 100% !important;
    }

    .drawer_modal .ivu-drawer .ivu-drawer-content {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }

    .drawer_modal .ivu-drawer .ls_drawer_footer {
      position: static;
      justify-content: center;
      transform: translate(0);
      /*position: fixed;*/
      /*bottom: 10vh;*/
      /*right: 350px;*/
      /*z-index: 2;*/
      /*display: flex;*/
      /*transform: translate(25%, 50%);*/
    }

    /*******TABS*******/
    .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper, .ivu-radio-group label.ivu-radio-group-item {
      margin-right: 12px;
      text-transform: none;
    }

    .ivu-tabs-nav .ivu-tabs-tab {
      font-size: 13px;
      padding: 10px 16px;
    }

    .ivu-date-picker input {
      max-width: 100%;
      width: 100%;
    }


    .ivu-table tr.ivu-table-row {
      background-color: rgba(206, 206, 206, 0.2);
      font-size: 13px;
    }

  }



  /*****************  ADAPTIVE *****************/
  @media screen and (max-width: 767px) {
    .box-header-filter .ivu-menu .menu-item{
      font-size: 12px;
    }


    .mb-30 {
      margin-bottom: 15px;
    }
  }



  /**************************  ADAPTIVE ******************/
  @media screen and (max-width: 575px) {

    .ivu-layout {
      padding-top: 61px;
    }


    .main-container__home {
      padding: 0 20px 25px 20px;
    }

    .main-container {
      padding: 10px 20px 20px 20px;
    }

    .layout-profile i {
      display: none;
    }
    .layout-profile .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown {
      width: 250px;
      right: 0 !important;
      left: auto !important;
    }

    .ivu-table th {
      font-size: 10px;
    }

    .ivu-drawer .ivu-drawer-body {
      padding: 20px;
    }

    input.ivu-input, textarea.ivu-input, .ivu-input-number {
      font-size: 14px;
    }

    button.ivu-btn, a.ivu-btn {
      font-size: 14px;
    }

    .ivu-select-input, .ivu-select .ivu-select-selection .ivu-select-placeholder, .ivu-checkbox-wrapper.ivu-checkbox-large {
      font-size: 14px;
    }

    .ivu-form label.ivu-form-item-label, .ivu-select-input {
      font-size: 14px;
    }

    .ivu-select .ivu-select-selection .ivu-select-selected-value {
      font-size: 14px;
    }

    .ivu-select .ivu-select-item {
      font-size: 14px !important;
    }

    .ivu-radio-group label.ivu-radio-group-item, .ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper {
      font-size: 13px;
    }
    .ivu-radio-group label.ivu-radio-group-item:last-child {
      margin-right: 0;
    }

    .ivu-dropdown .ivu-select-dropdown .ivu-dropdown-item {
      font-size: 13px !important;
    }

    .videoList .ivu-select-dropdown {
      top: 60px!important;
      transform: translateX(0);
      min-width: 300px;
      padding: 16px;
    }



  }

  @media screen and (max-width: 480px) {
    .ivu-picker-panel-body-date .ivu-picker-panel-content-right {
      display: none;
    }

    .ivu-date-picker-with-range .ivu-picker-panel-body {
      min-width: auto;
    }
  }

  @media screen and (max-width: 440px) {
    .modalMenu .ivu-modal {
      width: 100% !important;
    }

    .videoList .ivu-select-dropdown {
      transform: translateX(60px);
    }
  }







</style>



// WEBPACK FOOTER //
// src/components/App.vue